import { render } from "./Arrecadacoes.vue?vue&type=template&id=fdb0a5ea&scoped=true"
import script from "./Arrecadacoes.vue?vue&type=script&lang=js"
export * from "./Arrecadacoes.vue?vue&type=script&lang=js"

import "./Arrecadacoes.vue?vue&type=style&index=0&id=fdb0a5ea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb0a5ea"]])

export default __exports__